import ClearIcon from "@mui/icons-material/Clear";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  Radio,
  RadioGroup,
} from "@mui/material";

import { Option } from "api/common/types/common.types";
import { useFieldContext } from "components/Forms/AppForm";

import { useNormalizedOptions } from "../fields/select/UseNormalizedOptions";
import ErrorMessage from "../helpers/ErrorMessage";

interface ClearableRadioGroupProps {
  label: string;
  required?: boolean;
  disableClear?: boolean;
  options: Option[] | string[];
}

const ClearableRadioGroup = ({
  label,
  required,
  disableClear = false,
  options = [],
}: ClearableRadioGroupProps) => {
  const field = useFieldContext<string>();

  const resetField = () => {
    field.setValue("");
  };
  const normalizedOptions = useNormalizedOptions(options);

  return (
    <FormControl>
      <FormLabel
        id={`${label}-radio-buttons-group-label`}
        color="secondary"
        required={required}
        sx={{
          fontSize: 14,
        }}
      >
        {label}
      </FormLabel>

      <RadioGroup
        aria-labelledby={`${label}-radio-buttons-group-label`}
        value={field.state.value}
        name={`${label}-radio-buttons-group`}
        onChange={(e) => field.handleChange(e.target.value)}
        row
        sx={{
          alignItems: "flex-start",
          pt: 0.5,
          ".MuiFormControlLabel-root": {
            ml: 0.5,
            mr: 0.5,
          },
        }}
      >
        {normalizedOptions.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            label={option.label}
            labelPlacement="end"
            control={
              <Radio
                size="small"
                sx={{
                  p: 0,
                  m: 0,
                }}
              />
            }
            sx={{
              ".MuiFormControlLabel-label": {
                fontSize: 13,
                pl: 0.5,
                pr: 0.5,
                mt: "2px",
              },
            }}
          />
        ))}
        {!disableClear && (
          <IconButton
            hidden={!field.state.value}
            size="small"
            aria-label={`clear-${label}`}
            onClick={resetField}
            sx={{ padding: "3px" }}
          >
            <ClearIcon sx={{ width: "16px", height: "16px" }} />
          </IconButton>
        )}
      </RadioGroup>
      <ErrorMessage />
    </FormControl>
  );
};

export default ClearableRadioGroup;
